var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        {
          staticClass: "box-card",
          attrs: { bordered: false, shadow: "never" },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "ueditor",
            },
            [
              _c("div", { staticClass: "text-center mb20 f-s-18" }, [
                _vm._v("会员开卡协议"),
              ]),
              _c("Tinymce", {
                model: {
                  value: _vm.agreement,
                  callback: function ($$v) {
                    _vm.agreement = $$v
                  },
                  expression: "agreement",
                },
              }),
            ],
            1
          ),
          _c(
            "el-card",
            {
              directives: [
                {
                  name: "hasPermi",
                  rawName: "v-hasPermi",
                  value: ["merchant:agreement:member:open:card:save"],
                  expression: "['merchant:agreement:member:open:card:save']",
                },
              ],
              staticClass: "fixed-card",
              attrs: { "dis-hover": "", shadow: "never", bordered: false },
            },
            [
              _c(
                "div",
                { staticClass: "acea-row row-center-wrapper" },
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "debounceClick",
                          rawName: "v-debounceClick",
                          value: _vm.handleSubmit,
                          expression: "handleSubmit",
                        },
                      ],
                      staticClass: "mt20",
                      attrs: { type: "primary" },
                    },
                    [_vm._v("保存")]
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }